// extracted by mini-css-extract-plugin
module.exports = {"popupText":"popupText--lWgk+","entityKey":"entityKey--F+x23"};